<template>
  <Card class="page-team">
    <div style="display: flex; margin-bottom: 15px">
      <div style="flex: 1; display: flex">
        <el-input
          v-model="name"
          placeholder="请输入团队名称"
          style="max-width: 350px"
          @keyup.enter.native="getQueryList"
        />
        <el-button
          type="primary"
          round
          style="margin-left: 30px"
          @click="getQueryList"
          >搜索</el-button
        >
      </div>
      <el-button type="primary" round style="margin-left: 230px" @click="add"
        >新增团队</el-button
      >
    </div>
    <Table :columns="columns" :data="dataSource" :loading="loading">
      <template slot-scope="{ row }" slot="action">
        <el-popover v-if="row.url" style="margin:0 5px;" @show="useqrcode(row)" placement="bottom-start" trigger="hover">
          <canvas :id="'canvas' + row.id"></canvas>
          <el-button type="text" size="mini" slot="reference">二维码</el-button>
        </el-popover>
        <el-button type="text" style="margin:0 5px" @click="edit(row)">编辑</el-button>
        <el-popconfirm title="确定删除该团队吗？" @confirm="remove(row)">
          <el-button slot="reference" type="text" class="error">删除</el-button>
        </el-popconfirm>
        <el-button type="text" style="margin:0 5px" @click="goPerson(row)">成员管理</el-button>
        <el-button type="text" style="margin:0 5px" @click="goPackage(row)">服务包管理</el-button>

      </template>
    </Table>
    <div style="margin-top: 16px; text-align: right">
      <Page
        :total="total"
        :current="page"
        :page-size="size"
        :page-size-opts="sizes"
        :show-total="true"
        :show-elevator="true"
        :show-sizer="true"
        @on-change="onCurrentChange"
        @on-page-size-change="onSizeChange"
      />
    </div>
    <Modal v-model="show" :mask-closable="false" width="550" @on-cancel="cancel">
      <div slot="header" style="text-align: center">
        <span>{{ cur.id ? "编辑团队" : "新增团队" }}</span>
      </div>
      <Form
        ref="form"
        :model="cur"
        :label-width="150"
        :rules="rule"
        label-position="right"
        style="margin-left: -40px;margin-right: 40px"
      >
        <FormItem label="团队名称" prop="name">
          <Input
            v-model.trim="cur.name"
            :maxlength="30"
            :disabled="read"
            placeholder="请填写团队名称"
          ></Input>
        </FormItem>
        <FormItem label="团队类型" prop="team_type">
          <Select v-model="cur.team_type">
            <Option :value="0" :key="0">上级团队</Option>
            <Option :value="1" :key="1">社区团队</Option>
          </Select>
        </FormItem>
        <!-- <FormItem label="可见范围" prop="visible_range">
          <Select v-model="cur.visible_range">
            <Option :value="0" :key="0">本团队患者</Option>
            <Option :value="1" :key="1">病种患者</Option>
          </Select>
        </FormItem> -->
        <FormItem label="管理病种" prop="disease_id">
          <Select
            v-model="cur.disease_id"
            :label-in-value="true"
            @on-change="handleDisease"
          >
            <Option v-for="d in disease" :key="d.id" :value="d.id">{{
              d.name
            }}</Option>
          </Select>
        </FormItem>
        <FormItem label="团队介绍" prop="intro">
          <Input
            v-model.trim="cur.intro"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            :maxlength="499"
            placeholder="请填写团队介绍"
          ></Input>
        </FormItem>
        <FormItem label="团队擅长" prop="speciality">
          <Input
            v-model.trim="cur.speciality"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            :maxlength="499"
            placeholder="请填写团队擅长"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <el-button v-if="!read" type="info" round @click="cancel"
          >取消</el-button
        >
        <el-button
          v-if="!read"
          type="primary"
          round
          :loading="modalLoading"
          @click="save"
          >保存</el-button
        >
      </div>
    </Modal>
  </Card>
</template>
<script>
import QRCode from 'qrcode'
import {
  getTeamListApi,
  updateTeamApi,
  addTeamApi,
  deleteTeamApi,
  getDeptListApi,
  getDiseaseListApi,
} from "../../api/manage";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      name: "",
      columns: [
        {
          title: "ID",
          align: "center",
          key: "id",
        },
        {
          title: "团队名称",
          align: "center",
          key: "name",
        },
        {
          title: "管理病种",
          align: "center",
          key: "disease_name",
        },
        {
          title: "所属科室",
          align: "center",
          key: "dept_name",
        },
        {
          title: "所属机构",
          align: "center",
          key: "institution_name",
        },
        {
          title: "创建时间",
          align: "center",
          key: "create_time",
          width: 120,
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
          width: 200
        },
      ],
      dataSource: [],
      cur: {},
      rule: {
        name: [
          { required: true, message: "请输入团队名称", trigger: "blur" },
          { required: true, message: "请输入团队名称", trigger: "change" },
          {
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: "请输入由中英文、数字以及下划线组成的团队名称", trigger: "blur"
          },
          {
            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]+$/, message: "请输入由中英文、数字以及下划线组成的团队名称",trigger: "change"
          },
        ],
        team_type: [
          {
            required: true,
            type: "number",
            message: "请选择团队类型",
            trigger: "change",
          },
        ],
        dept_id: [
          {
            required: true,
            type: "number",
            message: "请选择所属科室",
            trigger: "change",
          },
        ],
        disease_id: [
          { required: true, message: "请选择管理病种", trigger: "change" },
        ],
        visible_range: [
          { required: true, type: "number", message: "请选择可见范围", trigger: "change" },
        ]
      },
      read: false,
      loading: false,
      show: false,
      modalLoading: false,
      total: 0,
      page: 1,
      size: 10,
      sizes: [10, 20, 30, 40, 50],
      deptLoading: false,
      dept: [],
      disease: [],
    };
  },
  computed: {
    ...mapGetters(["shift"]),
  },
  created() {
    this.getList();
    // this.getDeptList();
    this.getDiseaseList();
  },
  methods: {
    useqrcode(row) {
      const canvas = document.getElementById('canvas' + row.id);
      QRCode.toCanvas(canvas, row.url || row.id, function (error) {
        if (error) console.error(error)
      });
    },
    onCurrentChange(current) {
      this.page = current;
      this.getList();
    },
    onSizeChange(size) {
      this.size = size;
      this.getList();
    },
    getQueryList() {
      this.page = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      const { page, size, name } = this;
      getTeamListApi({ page, size, name, need_page: 1 })
        .then((res) => {
          this.loading = false;
          if (res.code === 0) {
            this.dataSource = res.data;
            this.total = res["x-total-count"];
            if(this.total && !this.dataSource.length && this.page > 1) {
              this.page = this.page - 1;
              this.getList();
            }
          } else {
            this.$Message.error(res.message);
          }
        })
        .catch(() => (this.loading = false));
    },
    getDeptList() {
      getDeptListApi({ page: 1, size: 999 }).then((res) => {
        if (res.code === 0) {
          this.dept = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    getDiseaseList() {
      getDiseaseListApi({ page: 1, size: 999 }).then((res) => {
        if (res.code === 0) {
          this.disease = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    handleDisease(d) {
      if (d) {
        this.cur.disease_id = d.value;
        this.cur.disease_name = d.label;
      }
    },
    handleDept(d) {
      if (d) {
        this.cur.dept_id = d.value;
        this.cur.dept_name = d.label;
      }
    },
    showModal() {
      this.show = true;
    },
    add() {
      this.cur = {
        name: "",
        intro: "",
        institution_id: this.shift.institution_id,
        institution_name: this.shift.institution_name,
        dept_id: this.shift.dept_id,
        dept_name: this.shift.dept_name,
        visible_range: 0,
        disease_id: "",
        disease_name: "",
        speciality: ""
      };
      this.showModal();
    },
    edit(row) {
      this.cur = JSON.parse(JSON.stringify(row));
      this.cur.visible_range = 0;
      this.showModal();
    },
    goPerson(row){
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'teamDoctorList',
        title: `${row.name}-成员管理`,
        key: `teamDoctorList?${row.id}`,
        extra: {
          row
        },
      })
    },
    goPackage(row) {
      this.$store.commit('setAllSelectedKeys', {
        type: 'add',
        name: 'package',
        title: `${row.name}-服务包管理`,
        key: `package?${row.id}`,
        extra: {
          row
        },
      })
    },
    remove(row) {
      deleteTeamApi(row.id).then((res) => {
        if (res.code === 0) {
          this.$Message.success("删除成功");
          this.getList();
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    cancel() {
      this.$refs.form.resetFields();
      this.show = false;
      this.modalLoading = false;
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.modalLoading = true;
          const callback = (res) => {
            this.modalLoading = false;
            if (res.code === 0) {
              this.cancel();
              this.getList();
            } else {
              this.$Message.error(res.message);
            }
          };
          if (this.cur.id) {
            updateTeamApi(this.cur)
              .then(callback)
              .catch(() => (this.modalLoading = false));
          } else {
            addTeamApi(this.cur)
              .then(callback)
              .catch(() => (this.modalLoading = false));
          }
        }
      });
    },
  },
};
</script>
<style lang="less">
.page-team {
  .error {
    color: #f56c6c;
    &:focus,
    &:hover {
      color: #f78989;
    }
  }
}
</style>
